import { AccessPointsPanel } from '../agent_install/AccessPointsPanel'
import { ConnectionQualityPanel } from '../agent_install/ConnectionQualityPanel'
import '../download_agent/DownloadAgentPage.css'
import './ConnectionQualitySettingsPage.css'
import { FloorListCard } from './FloorListCard'

/**
 * Settings -> Connection Quality: setarea de firma, lista AP-urilor si drumul
 * spre planurile de etaj, pe o pagina a lor.
 *
 * Pana pe 30 septembrie 2026 stateau ca al treilea panou in Install Options,
 * la care nu ducea nicio intrare de meniu - un om caruia i se explica unde sa
 * aprinda modulul n-avea pe unde sa ajunga. Acum au intrarea lor in meniul
 * Settings, sub Agent Install.
 *
 * Asezarea e a lui Agent Install (titlul mare, pasi numerotati, carduri albe):
 * stanga implicitul firmei, dreapta planurile de etaj sus - vizibile fara
 * derulare - si AP-urile sub ele. Sub 1200px coloanele trec una sub alta.
 *
 * Din 30 septembrie 2026 cardul Floor plans tine lista etajelor chiar aici
 * (`FloorListCard`), nu doar un buton spre `/app/settings/floor_plans`.
 */
export function ConnectionQualitySettingsPage() {
  return (
    <div className="page-content-wrapper" data-page="connection-quality-settings">
      <div className="od-cq">
        <div className="od-da-hero">
          <h2>Connection Quality</h2>
          <p>
            Measures how good each device&apos;s connection is: to the router, to the internet provider and to the target,
            the Wi-Fi signal and access point, and the speed. <strong>Off by default.</strong> Turn it on here for the whole
            company, or per device from its Agent Settings &rarr; Functions.
          </p>
        </div>
        <div className="od-cq-cols">
          <div className="od-cq-main">
            <ConnectionQualityPanel />
          </div>
          <aside className="od-cq-side">
            <FloorListCard />
            <AccessPointsPanel />
          </aside>
        </div>
      </div>
    </div>
  )
}
